<template>
  <QueryView
    ref="queryView"
    :table-config="tableConfig"
    :town-selection="false"
    :region-selection="true"
    :province-selection="true"
  />
</template>

<script setup>
import {ref} from 'vue';
import {useClipboard} from '@vueuse/core';
import QueryView from '../QueryView';
import QueryTableConfig from '../query-table.view-config.js';
import {WAYS_ST_JAMES_SCHEMA} from './query-ways-st-james-table.view-config';
import {searchWayStJames} from '@/api/way-st-james/way-st-james.api';
import {
  searchWayStJamesHtml,
  searchWayStJamesPdf,
  getWayStJamesPdf,
} from '@/api/way-st-james/way-st-james.api.pdf.js';
// #region Props, Emits

// #endregion

// #region Params, Ref, Reactives, Computed
const queryView = ref();
const {copy} = useClipboard();
// #endregion

// #region Functions
async function goWayStJames({coordinates, name, visible}) {
  const goCoordinates = queryView?.value?.goCoordinates;
  const zoom = 10;
  if (!!goCoordinates) {
    goCoordinates({coordinates, name, visible, zoom});
  }
}
function wayStJamesToText({name, length}) {
  const res = `
    Nombre: ${name}
    Longitud: ${length}
    `;
  return res;
}
async function printWayStJames(data) {
  const printRecord = queryView?.value?.printRecord ?? null;
  if (!!printRecord) {
    await printRecord(
      data.id,
      'Camino de Santiago - ' + data.name,
      getWayStJamesPdf,
    );
  }
}
async function htmlWayStJamesQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery(
      'Informe Camino de Santiago',
      searchWayStJamesHtml,
      'html',
    );
  }
}
async function printWayStJamesQuery() {
  const printQuery = queryView?.value?.printQuery ?? null;
  if (!!printQuery) {
    await printQuery('Informe Camino de Santiago', searchWayStJamesPdf);
  }
}
// #endregion
// functions previously defined
const tableConfig = new QueryTableConfig({
  title: '',
  api: searchWayStJames,
  recordToText: wayStJamesToText,
  copyClipboard: copy,
  htmlQuery: htmlWayStJamesQuery,
  printQuery: printWayStJamesQuery,
  printRecord: printWayStJames,
  centerMap: goWayStJames,
  schema: WAYS_ST_JAMES_SCHEMA,
});
// #region Effects, Hooks

// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped></style>
